import React from "react";
import { FooterLink } from "../../types/interfaces";
import "../../styles/ContactInfo.css";

interface ContactInfoProps {
  address: string;
  email: string;
  socialLinks: FooterLink[];
}

const socialMarks: Record<string, string> = {
  LinkedIn: "in",
  X: "X",
  WhatsApp: "WA",
  "WhatsApp Channel": "WA",
  Telegram: "TG",
  TikTok: "♪",
  "Founder LinkedIn": "in",
};

const ContactInfo: React.FC<ContactInfoProps> = ({ address, email, socialLinks }) => (
  <aside className="contact-info" aria-labelledby="contact-social-title">
    <div className="contact-info-heading">
      <h2 id="contact-social-title">Find AlluraTech online</h2>
      <p>Follow updates, meet the community, and explore what we are building.</p>
    </div>

    <ul className="contact-social-list">
      {socialLinks.map((link) => (
        <li key={link.name}>
          <a href={link.href} target="_blank" rel="noopener noreferrer">
            <span className={`contact-social-mark contact-social-mark--${link.name.toLowerCase().replace(/[^a-z]+/g, "-")}`} aria-hidden="true">
              {socialMarks[link.name] || "↗"}
            </span>
            <span className="contact-social-copy">
              <strong>{link.label || link.name}</strong>
              {link.description && <small>{link.description}</small>}
            </span>
            <span className="contact-social-arrow" aria-hidden="true">↗</span>
          </a>
        </li>
      ))}
    </ul>

    <div className="contact-info-details">
      <div>
        <span className="contact-info-detail-label">Our base</span>
        <strong>{address}</strong>
      </div>
      <div>
        <span className="contact-info-detail-label">Email</span>
        <a href={`mailto:${email}`}>{email}</a>
      </div>
    </div>
  </aside>
);

export default ContactInfo;
